import {
  MEMBER_INFO_FETCH,
  MEMBER_INFO_FETCH_SUCCESS,
  MEMBER_INFO_FETCH_FAIL,

  MEMBER_CHANGE_PASS,
  MEMBER_CHANGE_PASS_SUCCESS,
  MEMBER_CHANGE_PASS_FAIL,

  MEMBER_EDIT,
  MEMBER_EDIT_SUCESS,
  MEMBER_EDIT_FAIL,

  FAVORITE_LIST_FETCH,
  FAVORITE_LIST_FETCH_SUCESS,
  FAVORITE_LIST_FETCH_FAIL,

  MEMBER_UPLOAD,
  MEMBER_UPLOAD_SUCESS,
  MEMBER_UPLOAD_FAIL,

  NOTIFICATION_FETCH,
  NOTIFICATION_FETCH_SUCCESS,
  NOTIFICATION_FETCH_FAIL,

  MEMBER_DELETE,
  MEMBER_DELETE_SUCCESS,
  MEMBER_DELETE_FAIL,

  MEMBER_HISTORY_FETCH,
  MEMBER_HISTORY_FETCH_SUCCESS,
  MEMBER_HISTORY_FETCH_FAIL,


  MEMBER_UPDATE_SHOW_NOTI,
  MEMBER_UPDATE_SHOW_NOTI_SUCESS,
  MEMBER_UPDATE_SHOW_NOTI_FAIL

} from '../actions'

/* member info */
export const memberInfoFetch = (memberInfo) => ({
  type: MEMBER_INFO_FETCH,
  payload: { memberInfo }
})

export const memberInfoFetchSuccess = (memberInfo) => ({
  type: MEMBER_INFO_FETCH_SUCCESS,
  payload: { memberInfo }
})

export const memberInfoFetchFail = (message) => ({
  type: MEMBER_INFO_FETCH_FAIL,
  payload: { message }
})

/* change password */
export const changePassFetch = (changePass) => ({
  type: MEMBER_CHANGE_PASS,
  payload: { changePass }
})

export const changePassFetchSuccess = (changePass) => ({
  type: MEMBER_CHANGE_PASS_SUCCESS,
  payload: { changePass }
})

export const changePassFetchFail = (message) => ({
  type: MEMBER_CHANGE_PASS_FAIL,
  payload: { message }
})

/* Edit info */
export const memberEditinfoFetch = (memberEditinfo) => ({
  type: MEMBER_EDIT,
  payload: { memberEditinfo }
})

export const memberEditinfoFetchSuccess = (memberEditinfo) => ({
  type: MEMBER_EDIT_SUCESS,
  payload: { memberEditinfo }
})

export const memberEditinfoFetchFail = (message) => ({
  type: MEMBER_EDIT_FAIL,
  payload: { message }
})

/* favorite list */
export const favoriteListFetch = (favoriteList) => ({
  type: FAVORITE_LIST_FETCH,
  payload: { favoriteList }
})

export const favoriteListFetchSuccess = (favoriteList) => ({
  type: FAVORITE_LIST_FETCH_SUCESS,
  payload: { favoriteList }
})

export const favoriteListFetchFail = (message) => ({
  type: FAVORITE_LIST_FETCH_FAIL,
  payload: { message }
})

/* upload file */
export const memberUpload = (memberUploadpic) => ({
  type: MEMBER_UPLOAD,
  payload: { memberUploadpic }
});

export const memberUploadSuccess = (memberUploadpic) => ({
  type: MEMBER_UPLOAD_SUCESS,
  payload: { memberUploadpic }
});

export const memberUploadFail = (message) => ({
  type: MEMBER_UPLOAD_FAIL,
  payload: { message }
});

/* ontification list */
export const ontificationListFetch = (ontificationList) => ({
  type: NOTIFICATION_FETCH,
  payload: { ontificationList }
})

export const ontificationListFetchSuccess = (ontificationList) => ({
  type: NOTIFICATION_FETCH_SUCCESS,
  payload: { ontificationList }
})

export const ontificationListFetchFail = (message) => ({
  type: NOTIFICATION_FETCH_FAIL,
  payload: { message }
})

/* delete */
export const memberDeleteFetch = (memberDelete) => ({
  type: MEMBER_DELETE,
  payload: { memberDelete }
});

export const memberDeleteFetchSuccess = (memberDelete) => ({
  type: MEMBER_DELETE_SUCCESS,
  payload: { memberDelete }
});

export const memberDeleteFetchFail = (message) => ({
  type: MEMBER_DELETE_FAIL,
  payload: { message }
});

/* history */
export const memberHistoryFetch = (memberHistory) => ({
  type: MEMBER_HISTORY_FETCH,
  payload: { memberHistory }
});

export const memberHistoryFetchSuccess = (memberHistory) => ({
  type: MEMBER_HISTORY_FETCH_SUCCESS,
  payload: { memberHistory }
});

export const memberHistoryFetchFail = (message) => ({
  type: MEMBER_HISTORY_FETCH_FAIL,
  payload: { message }
});


export const memberUpdateShowNotiFetch = (memberUpdateShowNoti) => ({
  type: MEMBER_UPDATE_SHOW_NOTI,
  payload: { memberUpdateShowNoti }
})

export const memberUpdateShowNotiFetchSuccess = (memberUpdateShowNoti) => ({
  type: MEMBER_UPDATE_SHOW_NOTI_SUCESS,
  payload: { memberUpdateShowNoti }
})

export const memberUpdateShowNotiFetchFail = (message) => ({
  type: MEMBER_UPDATE_SHOW_NOTI_FAIL,
  payload: { message }
})